/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserRoleFromJSON, UserRoleToJSON, } from './';
export function EmployeeCreateRequestFromJSON(json) {
    return EmployeeCreateRequestFromJSONTyped(json, false);
}
export function EmployeeCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'userRole': !exists(json, 'userRole') ? undefined : UserRoleFromJSON(json['userRole']),
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'phoneNumberPrefix': !exists(json, 'phoneNumberPrefix') ? undefined : json['phoneNumberPrefix'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}
export function EmployeeCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'userName': value.userName,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'isActive': value.isActive,
        'userRole': UserRoleToJSON(value.userRole),
        'phoneNumber': value.phoneNumber,
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'password': value.password,
    };
}
